export default __webpack_public_path__ + "static/media/mayo.d6d42e3a.png";